import store from '@/store/index.js'

const index = () => import('./index')
const ComplementAssignor = () => import('./complement-assignor')
const assignor = () => import('./assignor')
const representative = () => import('./representative')
const BankAccount = () => import('./bank-account')
const docs = () => import('./docs')
const success = () => import('./success')
const sended = () => import('./sended')

const validateStatusAssignor = async (to, from, next) => {
  await store._actions['profile/fetch'][0]()
  const current = store.state.profile.current

  if (current.assignor.is_progress) {
    next({name: 'steps.sended'})
  } else {
    next()
  }
}

export default [
  {
    path: '/steps/index',
    name: 'steps.index',
    component: index,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => validateStatusAssignor(to, from, next)
  },
  {
    path: '/steps/sended',
    name: 'steps.sended',
    component: sended,
    meta: { requiresAuth: true }
  },
  {
    path: '/steps/complete_assignor',
    component: ComplementAssignor,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => validateStatusAssignor(to, from, next),
    children: [
      {
        path: '/',
        name: 'steps.complete_assignor.assignor',
        component: assignor,
        meta: { requiresAuth: true }
      },
      {
        path: 'representative',
        name: 'steps.complete_assignor.representative',
        component: representative,
        meta: { requiresAuth: true }
      },
      {
        path: 'bank-account',
        name: 'steps.complete_assignor.bank-account',
        component: BankAccount,
        meta: { requiresAuth: true }
      },
      {
        path: 'docs',
        name: 'steps.complete_assignor.docs',
        component: docs,
        meta: { requiresAuth: true }
      },
      {
        path: 'success',
        name: 'steps.complete_assignor.success',
        component: success,
        meta: { requiresAuth: true }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/features/steps/routes.js